export function isNotMultiPicklistToSinglePicklist(mappingValue): boolean {
  let thisSide, otherSide;
  if (mappingValue.target === mappingValue.destination_value_identifier) {
    [thisSide, otherSide] = [mappingValue.source, mappingValue.destination];
  } else if (mappingValue.target === mappingValue.source_value_identifier) {
    [thisSide, otherSide] = [mappingValue.destination, mappingValue.source];
  }

  if (thisSide?.origin && otherSide?.origin) {
    if (thisSide.isMultiPicklist) {
      return otherSide.isMultiPicklist || !otherSide.isSinglePicklist
    }
  }
  return true
}

// Built below out to try and make the picklist error more generic
// Since it's the only one for now, I've made a more targeted validator
// but the code below may work with the warning validator in the mapping value
// validation to handle a number of data type validators at the Error level

// dataTypeValidationLevelIsError(mappingValue): boolean {
//   const types = {
//     Salesforce: [
//       sft.multipicklist,
//       sft.picklist
//     ],
//     ObjectModelProperty: [
//       omp.PickList
//     ]
//   }
//   const source = mappingValue.source
//   const destination = mappingValue.destination
//   if (mappingValue.type === ModelMappingValuesType.Value && !!source.origin && !!destination.origin) {
//     if (source instanceof ModelMappingValueOriginFormElement || destination instanceof ModelMappingValueOriginFormElement) {
//       //nothing yet
//     }
//     if (source instanceof ModelMappingValueOriginObjectModelProperty || destination instanceof ModelMappingValueOriginObjectModelProperty) {
//       return this.isOneOf(source.enumValueType, destination.enumValueType, types.ObjectModelProperty);
//     }
//     if (source instanceof ModelMappingValueOriginSalesforce) {
//       return this.isOneOf(source.enumValueType, destination.enumValueType, types.Salesforce);
//     }
//   }
// }

// private isOneOf(a, b, arr) {
//   return arr.includes(a) || arr.includes(b);
// }

// dataTypeErrorValidator(): NavigableValidator<ModelMappingValue> {
//   return new NavigableValidator({
//     validatorKey: 'dataTypeError',
//     section: ValidationModalSection.ValueMappings,
//     conditional: (model: ModelMappingValue): boolean => {
//       return (
//         model.type === ModelMappingValuesType.Value &&
//         !!model.destination_value_identifier &&
//         !!model.destination && this.dataTypeValidationLevelIsError(model)
//       );
//     },
//     validator: (value, model: ModelMappingValue) => {
//       return model.areMappingDataTypesCompatible
//     },
//     message: "Data types must be compatible",
//     type: ErrorType.dataTypeMismatchError,
//     path: "layout",
//     displayName: (key, model: ModelMappingValue) => {
//       return `${model.source.value?.label} (${model.source.valueType}) -- ${model.directionDisplay} -- ${model.destination.value?.label} (${model.destination.valueType})`
//     },
//     beforeReveal: async () => {
//       await window.requestAnimationFrame(async () => {
//         await this.scrollToAndOpenModelMapping();
//       })
//     },
//     containerElementSelector: ".scroll-area.mapping-area",
//   })
// }